export default "__VITE_ASSET__CjcdOzTO__"